import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";

import FormDialog from "../Dialogs/FormDialog";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import moment from "moment";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  }
}));

export default function InteractiveTable(props) {
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editDialogFields, setEditDialogFields] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const onEditDialogOpen = (_event, row) => {
    var formFields = [];
    row.forEach((col, index) => {
      (typeof col === "string" || typeof col === "number") &&
        formFields.push({
          id: props.dataKeys[index].id,
          disabled: props.dataKeys[index].disabled,
          label:
            (props.dataKeys[index] && props.dataKeys[index].column.name) || "",
          type: (props.dataKeys[index] && props.dataKeys[index].type) || "text",
          items: props.dataKeys[index] && props.dataKeys[index].items,
          defaultValue: col
        });
    });
    setEditDialogFields(formFields);
    setEditDialogOpen(true);
  };

  const onDialogClose = (event, response) => {
    setDeleteDialogOpen(false);
    setEditDialogOpen(false);
    if (response !== undefined && response !== "backdropClick") {
      response.volunteer = response.volunteer === "yes" ? true : false;
      response.registrationEmail = response.registrationEmail.includes("Sent")
        ? true
        : false;
      firebase
        .database()
        .ref(`users/${response.bibNumber}`)
        .update(response);
    }
  };

  useEffect(() => {
    if (props.firestore) {
      firebase
        .firestore()
        .collection("Users")
        .get()
        .then(snapshot => {
          if (snapshot.empty) {
            console.log("No matching documents.");
            return;
          }
          updateTableData(snapshot);
        });
    } else {
      firebase
        .database()
        .ref(props.firebaseRef)
        .on("value", snapshot => updateTableData(snapshot));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  const updateTableData = snapshot => {
    var docs = [];
    snapshot.val().forEach((row, index) => {
      var tableRow = [];
      props.dataKeys.forEach((key, tindex) => {
        if (key.id === "registrationEmail") {
          const minor =
            moment(row["dob"], "YYYY-MM-DD")
              .fromNow()
              .split(" ")[0] < 18;
          tableRow.push(
            row[key.id]
              ? `Sent ${minor ? "(minor)" : ""}`
              : minor
              ? "Need Consent"
              : "Needed"
          );
        } else if (row[key.id] === true) {
          tableRow.push("yes");
        } else if (row[key.id] === false) {
          tableRow.push("no");
        } else if (row[key.id] === undefined) {
          tableRow.push("-");
        } else {
          tableRow.push(row[key.id]);
        }
      });
      tableRow.push(
        <IconButton
          className={classes.button}
          aria-label="Edit"
          id={index}
          onClick={(event, row) => onEditDialogOpen(event, tableRow)}
        >
          <EditIcon />
        </IconButton>
      );
      docs.push(tableRow);
    });
    setTableData(docs);
  };

  useEffect(() => {
    tableData.forEach((row, index) => {
      tableData[index][14] = props.staticData[0][index];
    });
    setTableData(tableData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.staticData, tableData]);

  useEffect(
    () => () => {
      console.log("unmount");
      firebase
        .database()
        .ref(props.firebaseRef)
        .off();
    },
    [props.firebaseRef]
  );

  return (
    <React.Fragment>
      <FormDialog
        title={"Edit user details"}
        open={editDialogOpen || deleteDialogOpen}
        fields={editDialogFields}
        onClose={onDialogClose}
      />
      <MUIDataTable
        title={props.title}
        columns={
          props.dataKeys && [
            ...props.dataKeys.map(key => key.column),
            "Actions"
          ]
        }
        options={props.options}
        data={tableData}
      />
    </React.Fragment>
  );
}

InteractiveTable.propTypes = {
  title: PropTypes.string.isRequired,
  dataKeys: PropTypes.array.isRequired,
  firebaseRef: PropTypes.string.isRequired,
  columns: PropTypes.array,
  firestore: PropTypes.bool,
  options: PropTypes.object,
  staticData: PropTypes.array
};
